import React, {useContext, useState} from "react";

import EditView from "../../component/EditView";
import Texto from "../../component/form/texto/Texto";
import Switch from "../../component/form/switch/Switch";

import Pergunta from "../../model/Pergunta";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import FormUtils from "../../utils/FormUtils";
import {TooltipPosition} from "../../component/form/TooltipPosition";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";

function PerguntaEdit() {
    const {error} = useContext(MensagemContext) as MensagemContextType;
    const [entidade, setEntidade] = useState<Pergunta>({ativo: true});

    const editEntidade = (data: Pergunta) => {
        setEntidade(data);
    }

    const entidadeOnChangeHandler = (e: any) => {
        setEntidade({...entidade, [e.target.id]: e.target.value});
    }

    const ativoOnChangeHandler = (e: any) => {
        setEntidade({...entidade, ativo: e.value});
    }

    const validar = async (): Promise<boolean> => {
        if (!entidade.descricao) {
            FormUtils.invalidarComponente(error, "Pergunta é obrigatório.");
            return false;
        }

        return true;
    }

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <EditView title={"Questionário"}
                          id={`${process.env.REACT_APP_REST_PERGUNTA}`}
                          entidade={entidade}
                          onValidationHandler={validar}
                          entidadeUseStateFunction={editEntidade}>

                    <Texto id={"descricao"} value={entidade.descricao}
                           label={"* Pergunta"} size={"100%"} maxLength={200}
                           placeholder={"Ex: Você costuma jantar fora durante a semana?"}
                           tooltip={"A pergunta que será exibida no app"}
                           tooltipPosition={TooltipPosition.TOP}
                           onChangeHandler={entidadeOnChangeHandler} />

                    <Switch id={"ativo"} checked={entidade.ativo === true}
                            label={entidade.ativo ? "Ativa" : "Inativa"}
                            onChangeHandler={ativoOnChangeHandler} />

                </EditView>
            </RoleBasedAccess>
        </>
    );
}

export default PerguntaEdit;
